// A tee may bring a horizontal run into a vertical chimney, but not send a vertical
// run out sideways. Elbows are excluded — the Bent Chimney template uses a 90° stove
// pipe elbow to turn vertical flow horizontal on the way to the wall.
// Vectors are canvas coordinates, y-down, so up is (0, -1).

const TEES = new Set(['tee', 'chimney-tee', 'masonry-tee']);

const isVertical = (v) => !!v && Math.abs(v.y) > Math.abs(v.x);
const isHorizontal = (v) => !!v && Math.abs(v.x) > Math.abs(v.y);
const isUpward = (v) => isVertical(v) && v.y < 0;

export function turnsVerticalToHorizontal(componentType, incoming, outgoing) {
  if (!TEES.has(componentType)) return false;
  // Downward flow has its own check; don't double-report it.
  return isUpward(incoming) && isHorizontal(outgoing);
}
